import type { AlertSeverity } from '../pages/markets/api/types';

export const SEVERITY_LABEL: Record<AlertSeverity, string> = {
    log: 'Log',
    info: 'Info',
    warning: 'Warn',
    critical: 'Crit',
};

export const SEVERITY_TOOLTIP: Record<AlertSeverity, string> = {
    log: 'Everything, including informational debug-level signals.',
    info: 'Typical activity worth noting. Default level for most signals.',
    warning: 'Notable activity — sharp moves or significant insider behavior.',
    critical: 'Highest-conviction only — strong edges and major shifts.',
};

export const SEVERITY_ORDER: AlertSeverity[] = ['log', 'info', 'warning', 'critical'];
